<img
  class="placeholder-image-on-error aspect-ratio-1 object-fit-contain w-100"
  [src]="logoUrl" />
